import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';

const ContactForm = () => {
  const form = useRef();
  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null }
  });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    category: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(prevStatus => ({ ...prevStatus, submitting: true }));

    try {
      await emailjs.sendForm(
        'service_x4fdl4f',
        'afw_contact_form',
        form.current,
        'h_IXs7eEN6obsWL1p'
      );

      setStatus({
        submitted: true,
        submitting: false,
        info: { error: false, msg: 'Message envoyé avec succès!' }
      });

      // Reset form
      setFormData({
        name: '',
        email: '',
        category: '',
        message: ''
      });

      // Clear success message after 5 seconds
      setTimeout(() => {
        setStatus({
          submitted: false,
          submitting: false,
          info: { error: false, msg: null }
        });
      }, 5000);

    } catch (error) {
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: true, msg: 'Une erreur s\'est produite. Veuillez réessayer.' }
      });
    }
  };

  return (
    <div className="w-full max-w-md mx-auto p-6 bg-black/50 rounded-xl border border-[#d4b084]/20">
      <h2 className="text-2xl font-serif text-[#d4b084] mb-6 text-center">Contactez-nous</h2>
      
      {status.info.msg && (
        <div className={`mb-4 p-4 rounded-lg text-center ${
          status.info.error ? 'bg-red-500/10 text-red-500' : 'bg-green-500/10 text-green-500'
        }`}>
          {status.info.msg}
        </div>
      )}

      <form ref={form} onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-[#d4b084] mb-1">Nom</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 bg-black/50 border border-[#d4b084]/30 rounded-lg text-white focus:outline-none focus:border-[#d4b084]"
          />
        </div>
        
        <div>
          <label htmlFor="email" className="block text-[#d4b084] mb-1">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 bg-black/50 border border-[#d4b084]/30 rounded-lg text-white focus:outline-none focus:border-[#d4b084]"
          />
        </div>
        
        <div>
          <label htmlFor="category" className="block text-[#d4b084] mb-1">Votre demande concerne</label>
          <select
            id="category"
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 bg-black/50 border border-[#d4b084]/30 rounded-lg text-white focus:outline-none focus:border-[#d4b084]"
          >
            <option value="">Sélectionnez une option</option>
            <option value="Un article">Un article</option>
            <option value="Une vente">Une vente</option>
            <option value="Un achat">Un achat</option>
            <option value="Autre">Autre</option>
          </select>
        </div>
        
        <div>
          <label htmlFor="message" className="block text-[#d4b084] mb-1">Message</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="4"
            className="w-full px-4 py-2 bg-black/50 border border-[#d4b084]/30 rounded-lg text-white focus:outline-none focus:border-[#d4b084]"
          ></textarea>
        </div>
        
        <button
          type="submit"
          disabled={status.submitting}
          className={`w-full bg-[#d4b084] text-black px-6 py-3 rounded-lg font-semibold transition-all duration-300 
            ${status.submitting 
              ? 'opacity-70 cursor-not-allowed' 
              : 'hover:bg-[#c19a6b] hover:shadow-lg hover:shadow-[#d4b084]/20'}`}
        >
          {status.submitting ? 'Envoi en cours...' : 'Envoyer'}
        </button>
      </form>
    </div>
  );
};

export default ContactForm; 